export const RESET = 'PRODUCTPRICETYPE_UPDATE_RESET'
export const SET_ERROR = 'PRODUCTPRICETYPE_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'PRODUCTPRICETYPE_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'PRODUCTPRICETYPE_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'PRODUCTPRICETYPE_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'PRODUCTPRICETYPE_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'PRODUCTPRICETYPE_UPDATE_UPDATE_RETRIEVED'



// WEBPACK FOOTER //
// ./src/store/modules/product_price_type/update/mutation_types.js